"use client";

import { createContext, type ReactNode, useContext, useEffect, useMemo, useState } from "react";
import LandingConversationFloat from "./LandingConversationFloat";

interface LandingConversationContextValue {
  setTargetCenterId: (centerId?: number) => void;
}

const LandingConversationContext = createContext<LandingConversationContextValue | undefined>(undefined);

export function LandingConversationProvider({ children }: { children: ReactNode }) {
  const [targetCenterId, setTargetCenterId] = useState<number>();
  const contextValue = useMemo(() => ({ setTargetCenterId }), []);

  return (
    <LandingConversationContext.Provider value={contextValue}>
      {children}
      <LandingConversationFloat key={targetCenterId ?? "domain"} targetCenterId={targetCenterId} />
    </LandingConversationContext.Provider>
  );
}

export function LandingConversationTarget({ targetCenterId }: { targetCenterId?: number }) {
  const context = useContext(LandingConversationContext);

  useEffect(() => {
    if (!context) return;

    context.setTargetCenterId(targetCenterId);
    return () => context.setTargetCenterId(undefined);
  }, [context, targetCenterId]);

  return null;
}
